import { getClientId } from "./clientId";
import { getApiBase } from "./apiBase";

const API_BASE = getApiBase({ trailingSlash: true });

export const PROFILE_UPDATED_EVENT = "qubiq-profile-updated";

export const syncClerkProfileToBackend = async ({ getToken }) => {
  const clientId = getClientId();
  if (!clientId || typeof getToken !== "function") return false;

  const token = await getToken().catch(() => null);
  const response = await fetch(`${API_BASE}auth/sync-counter`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-client-id": clientId,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ clientId }),
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error("profile_sync_failed");
  }

  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event("qubiq-notifications-refresh"));
    window.dispatchEvent(new Event(PROFILE_UPDATED_EVENT));
  }

  return true;
};
